import $ from 'jquery';
import debounce from 'lodash/debounce';

import ScrollHandler from '@core/base/scripts/classes/ScrollHandler';
import Utils from '@core/base/scripts/utils/utils';
import A11yUtils from '@core/base/scripts/utils/a11y-utils';


export default class BaseModule {
  constructor() {
    this.TIMEOUT = 100;
    this.TRANSLATION = 100;
    this.RESIZE_TIME = 300;
    this.VISIBLE_AREA = 0;
    this.CLASSES = {
      ready: 'base-module--ready',
      visible: 'base-module--visible'
    };
    //
    this._name;
    this._elements;
    this.timer;
    this.scrollHandler;
    this.revealOnScroll = false;
  }

  init(callback) {
    console.log('Module initialized :', this.name);

    $(document).ready(() => {
      this.elements = $('.module-' + this.name);
      if (this.elements && this.elements.length > 0) {
        console.log(this.elements.length+ ' modules found: '+ this.name+' ready');
        setTimeout(()=>{
          this.elements.addClass(this.CLASSES.ready);
          A11yUtils.targetBlankLabelling(this.elements);
          //

          //
          if (callback) {
            callback(this);
          }
          if (this.revealOnScroll && !Utils.isTablet) {
            setTimeout(() => {
              this.initScroll();
            }, 0);
          } else if (Utils.isTablet || !this.revealOnScroll) {
            this.elements.addClass(this.CLASSES.visible);
          }
        }, this.TIMEOUT);
      }
    });
  }

  initScroll() {
    this.scrollHandler = new ScrollHandler();
    this.scrollHandler.init();
    this.scrollHandler.onScroll((scrollDown, scrollTop) => {
      if (scrollDown && scrollTop < $(document).height()) {
        this.scrollReveal(scrollTop);
      }
    });
    this.scrollReveal($(window).scrollTop());
  }

  scrollReveal(scrollTop) {
    const len = this.elements.length;
    const windowHeight = $(window).height();

    //loop on each module in the page
    for (let index = 0; index < len; index++) {
      const $element = $(this.elements[index]);
      const offset = $element.offset().top - (windowHeight - this.VISIBLE_AREA);
      const isVisible = $element.hasClass(this.CLASSES.visible);
      var elementToReveal;

      //check if current module is visible, if not set some style to prepare the reveal animation
      if (!isVisible) {
        $element.css({
          transform: `translateY(${this.TRANSLATION}px)`,
          opacity: 0
        });
        //check if the current module is entering in the viewport, if yes set the elementToReveal var
        if (scrollTop >= offset) {
          elementToReveal = $element;
        }
      }
    }

    //check if the elementToReveal exists, if yes make it visible with some animations
    if (elementToReveal && elementToReveal.length > 0) {
      console.log('Base module elementToReveal on scroll:', String(elementToReveal[0].classList));
      elementToReveal.addClass(this.CLASSES.visible);
      elementToReveal.animate({
        transform: 'translateY(0)',
        opacity: 1
      }, 0, () => {
        elementToReveal.removeAttr('style');
      });
    }
  }

  removeStyle($element) {
    $element.removeAttr('style');
  }

  onResize(callback) {
    const debouncedResize = debounce(() => {
      if (callback) {
        callback(this);
      }
    }, this.RESIZE_TIME);
    $(window).on('resize', debouncedResize);
    debouncedResize();
  }

  set name(str) {
    this._name = str;
  }

  get name() {
    return this._name;
  }

  set elements(elt) {
    this._elements = elt;
  }

  get elements() {
    return this._elements;
  }
}
